import * as React from "react";

function ScaleBalancedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 336c0-16.12 1.375-8.75-85.12-181.5C162.1 136.9 145 128 128 128s-34.12 8.9-43 26.5C-1.998 328.8.002 320.4.002 336c0 44.13 57.25 80 127.1 80S256 380.1 256 336zM127.9 176l72.2 144H55.96l71.94-144zm391.2 288H344V155.9c27.4-8.7 48.6-31.3 54.4-59.9H520c13.25 0 23.1-10.75 23.1-23.1 0-14.15-9.8-24.9-24-24.9H392.4C380.9 19.75 352.7 0 320 0s-60.9 19.75-73.2 48H120c-13.25 0-23.1 10.75-23.1 23.1S106.7 96 120 96h121.6c5.75 28.62 27 51.25 54.38 59.88V464H120c-13.25 0-23.1 10.75-23.1 23.1S106.7 512 120 512h399.1c13.25 0 23.1-10.75 23.1-23.1.9-14.2-8.9-24.9-23.1-24.9zM320 112c-17.62 0-31.1-14.38-31.1-32s14.37-32 31.1-32 31.1 14.38 31.1 32-13.5 32-31.1 32zm319.1 224c0-16.12 1.375-8.75-85.12-181.5-7.88-17.6-25.88-26.5-42.88-26.5s-34.13 8.875-43 26.5C382 328.8 384 320.4 384 336c0 44.13 57.25 80 128 80s127.1-35.9 127.1-80zm-200-16s53.46-106.5 71.96-144l72.17 144H439.1z"
  }));
}

const ForwardRef = React.forwardRef(ScaleBalancedIcon);
export default ForwardRef;